import HardwareSerializer from 'eflex/serializers/hardware';

export default class OpenProtocolToolSerializer extends HardwareSerializer {}
